module.exports = __webpack_public_path__ + "img/image17.92ad93f1.png";